import { render, staticRenderFns } from "./GuppyFloatingChatList.vue?vue&type=template&id=4ed31891&"
import script from "./GuppyFloatingChatList.vue?vue&type=script&lang=js&"
export * from "./GuppyFloatingChatList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyFloatingChatList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports